module.exports = __webpack_public_path__ + "img/43.5cc7433a.jpg";